import { render } from "./BoardView.vue?vue&type=template&id=b410040e&scoped=true"
import script from "./BoardView.vue?vue&type=script&lang=js"
export * from "./BoardView.vue?vue&type=script&lang=js"

import "./BoardView.vue?vue&type=style&index=0&id=b410040e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b410040e"]])

export default __exports__